import { Box, Text } from '@zillow/constellation';
import React from 'react';
import { omitUndefined } from '../../utils/lodash.js';
import { commaSeparateNumber } from '../../utils/zhl-calculator.js';
import CalculatorForm from '../CalculatorForm/CalculatorForm.js';
import { FieldConfig, useLastValidHelocValues } from './HelocCalculator.utils.js';
import HelocFields from './HelocFields.js';

var HelocCalculator = function HelocCalculator(_ref) {
  var _Object$assign;
  var defaultValues = _ref.defaultValues,
    editorMode = _ref.editorMode;
  return /*#__PURE__*/React.createElement(Box, {
    as: CalculatorForm,
    fieldStorageKey: "helocFields",
    defaultValues: Object.assign((_Object$assign = {}, _Object$assign[FieldConfig.homeValue.name] = 400000, _Object$assign[FieldConfig.loanBalance.name] = 300000, _Object$assign), omitUndefined(defaultValues)),
    editorMode: editorMode,
    sx: {
      paddingbottom: '$spacing.md',
      display: 'flex',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React.createElement(HelocFields, null), /*#__PURE__*/React.createElement(Box, {
    sx: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    fontType: "h4",
    as: "p"
  }, "Estimated credit line*"), /*#__PURE__*/React.createElement(Text, {
    fontType: "h4",
    fontColor: "green400",
    as: "p",
    marginBottom: "sm",
    title: "Estimated credit line"
  }, /*#__PURE__*/React.createElement(CreditLine, null)), /*#__PURE__*/React.createElement(Text, {
    fontType: "finePrint",
    as: "p",
    marginBottom: "sm"
  }, "*based on a 85% combined loan-to-value (CLTV) ratio"), /*#__PURE__*/React.createElement(Text, {
    fontType: "finePrint",
    as: "p"
  }, "The HELOC limit calculator is for informational purposes only and the estimates are based on information you provide. Actual available HELOC credit lines are subject to individual lender underwriting criteria and will depend on a number of factors, including CLTV ratios and property valuations. Zillow Group Marketplace, Inc. does not make loans and this is not a commitment to lend.")));
};
var CreditLine = function CreditLine() {
  var lastValidValues = useLastValidHelocValues();
  return "$" + commaSeparateNumber(lastValidValues.calculations.creditLine);
};
var HelocCalculator$1 = HelocCalculator;

export { HelocCalculator$1 as default };
